<template>
  <v-btn :loading="loading" color="grey" outline :small="small" @click="exportxlsx">
    <em class="fas fa-file-export"></em>
    &nbsp;
    {{ $t('export') }}&nbsp;
  </v-btn>
</template>

<script>
import XLSX from 'xlsx'
export default {
  name: 'ExportXlsx',
  props: {
    value: {
      type: Array,
      default: () => [],
      require: true
    },
    // eslint-disable-next-line vue/require-default-prop
    promisedValue: {
      type: Function
    },
    filename: {
      type: String,
      default: 'exportedfile'
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async exportxlsx() {
      this.loading = true
      let json = []
      if (this.promisedValue) {
        json = await this.promisedValue()
      } else {
        json = this.value
      }

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.filename + '.xlsx')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/exportxlsx.vue